import { useState } from 'react';
import { motion } from 'framer-motion';
import FAQAccordionItem from './FAQAccordionItem';
import { getFaqs } from './faqData';
import { useLang } from '@/lib/LanguageContext';

export default function FAQSection({ faqs: faqsProp }) {
  const [openIndex, setOpenIndex] = useState(null);
  const { t, language } = useLang();
  const faqs = faqsProp || getFaqs(language);

  return (
    <section id="faq" className="relative py-32 overflow-hidden">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8 }}
          className="text-center mb-16">
          <span className="text-xs font-inter font-medium tracking-[0.3em] uppercase text-primary mb-4 block">
            {t('Got Questions?')}
          </span>
          <h2 className="font-inter font-black text-4xl md:text-5xl tracking-[-0.03em] text-foreground mb-4">
            {t('Frequently Asked Questions')}
          </h2>
          <div className="w-16 h-px bg-primary/40 mx-auto" />
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-100px' }}
          transition={{ duration: 0.8, delay: 0.15 }}>
          <div className="space-y-4">
            {faqs.map((faq, i) => (
              <FAQAccordionItem
                key={i}
                question={faq.question}
                answer={faq.answer}
                link={faq.link}
                isOpen={openIndex === i}
                onToggle={() => setOpenIndex(openIndex === i ? null : i)}
              />
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}